import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

export default class DropdownMenu extends Component {
  static propTypes = {
    buttonComponent: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    menuStyle: PropTypes.object,
    listStyle: PropTypes.object,
    menuPosition: PropTypes.string,
    subMenu: PropTypes.bool,
  }
  constructor() {
    super();
    this.state = {
      parentActive: false,
      childActive: false,
      childActiveId: null,
      toggle: false,
    };
    this.onClick = this.onClick.bind(this);
    this.onBlurMenuActions = this.onBlurMenuActions.bind(this);
    this.trackPopover = this.trackPopover.bind(this);
    this.untrackPopover = this.untrackPopover.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.enter = this.enter.bind(this);
    this.exit = this.exit.bind(this);
    this.checkForOuterAction = this.checkForOuterAction.bind(this);
  }

  componentDidUpdate(propsPrev, statePrev) {
    const didOpen = !statePrev.toggle && this.state.toggle;
    const didClose = statePrev.toggle && !this.state.toggle;

    if (didOpen) this.enter();
    else if (didClose) this.exit();
  }

  componentWillUnmount() {
    if (this.hasTracked) this.untrackPopover();
  }

  open() {
    this.setState({ toggle: true });
  }

  close() {
    this.setState({ toggle: false });
  }

  enter() {
    this.trackPopover();
  }

  exit() {
    this.untrackPopover();
  }

  trackPopover() {
    this.hasTracked = true;
    /* Track user actions on the page. Anything that occurs _outside_ the Popover boundaries
    should close the Popover. */

    document.addEventListener("mousedown", this.checkForOuterAction)
    document.addEventListener("touchstart", this.checkForOuterAction)
  }

  checkForOuterAction(event) {
    const MenuListEle = document.getElementsByClassName("multi-level-menu-list-container");
    const isOuterMenuListAction = MenuListEle[0] ? !MenuListEle[0].contains(event.target) : true;
    const isOuterAction = !this.containerEl.contains(event.target) && isOuterMenuListAction;
    if(MenuListEle[0] && isOuterMenuListAction && !isOuterAction) {
      MenuListEle[0].remove();
    } else if (MenuListEle[0] && isOuterAction) {
      MenuListEle[0].remove();
      this.onBlurMenuActions();
    } else if(isOuterAction) {
      this.onBlurMenuActions();
    }
  }

  untrackPopover() {
    document.removeEventListener("mousedown", this.checkForOuterAction);
    document.removeEventListener("touchstart", this.checkForOuterAction);
    this.hasTracked = false;
  }

  onClick() {
    const { parentActive , childActive} = this.state;
    if(childActive) {
      this.setState({ childActive: false });
    }
    this.setState({
      parentActive: !parentActive,
    });
    if(!parentActive) {
      this.open();
    } else {
      this.close();
    }
  }

  onBlurMenuActions() {
    this.setState({
      parentActive: false,
      childActive: false,
      childActiveId: null,
      toggle: false,
    });
  }

  renderDropdownButton() {
    const { buttonComponent } = this.props;
    return (
      <span className='menu-button' onClick={ this.onClick }>
        { buttonComponent }
      </span>
    );
  }

  renderDropdownItems() {
    let { children, subMenu } = this.props;
    children = Array.isArray(children) ? children : [children];
    if(subMenu) {
      return (
        children.map((child, index) => {
          if(child && child.props.id) {
            const childId = child.props.id;
            const childName = child.props.name;
            const subChildren = child.props.children;
            return (
              <li onClick={ () => this.setState({ parentActive: false, childActive: true, childActiveId: childId, }) } key={ index }>
                <span className='justify-space-between sub-menu'><div>{ childName }</div><i className='material-icons'>keyboard_arrow_right</i></span>
              </li>
            );
          } else {
            return (
              <li onClick={ () => this.setState({ parentActive: false }) } key={ index }>{ child }</li>
            );
          }
        })
      );
    }
    return (
      children.map((child, index) => {
        return (
          <li onClick={ () => this.setState({ parentActive: false }) } key={ index }>{ child }</li>
        );
      })
    );
  }

  renderSubDropdownItems() {
    let { children, subMenu, menuPosition, listStyle } = this.props;
    const { childActive, childActiveId } = this.state;
    const ulPosition = menuPosition === 'right' ? { right: 0 } : { left: 0 };
    children = Array.isArray(children) ? children : [children];

    if(subMenu) {
      return (
        children.map((child) => {
          if(child && child.props.id) {
          const childId = child.props.id;
          let subChildren = child.props.children;
          subChildren = Array.isArray(subChildren) ? subChildren : [subChildren];

          return (
            <ul key={'sub-list' + childId} className={ classNames({ 'childActive': childActive === true && childActiveId === childId }) }
              style={ { ...ulPosition, ...listStyle } }>
            {
              subChildren.map((child, index) => {
                if(index === 0) {
                  return (
                    <li onClick={ () => this.setState({ parentActive: true, childActive: false, childActiveId: null }) } key={ index }>{ child }</li>
                  );
                }
                return (
                  <li onClick={ () => this.setState({ childActive: false, childActiveId: null }) } key={ index }>{ child }</li>
                );
              })
            }
            </ul>
          );
          }
        })
      );
    }
  }

  render() {
    const { menuStyle, menuPosition, listStyle } = this.props;
    const { parentActive } = this.state;
    const ulPosition = menuPosition === 'right' ? { right: 0 } : { left: 0 };

    return (
      <div ref={ (ref) => this.containerEl = ref } tabIndex='0' className={'dropdown-menu'} style={ menuStyle } aria-expanded={ parentActive ? 'true' : 'false' }>
        { this.renderDropdownButton() }
        <ul id='customize-scrollbar' key='parent-list' className={ classNames({ parentActive }) } style={ { ...ulPosition, ...listStyle } }>
          { this.renderDropdownItems() }
        </ul>
        { this.renderSubDropdownItems() }
      </div>
    );
  }
}
